import {
  TrainingsCategoriesDocument,
  TrainingsCategoriesQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type TrainingsCategory = NonNullable<
  NonNullable<NonNullable<TrainingsCategoriesQuery['trainings']>['categories']>[0]
>

export const useTrainingsCategories = () => {
  const { loading, data } = useQuery(TrainingsCategoriesDocument)

  return {
    loading,
    categories: data ? data.trainings.categories : undefined, // Provide a default value
  }
}
